import { SimplePageHeader } from '@flexinet/ui-components';

export const PersonasPageHeader = () => {
    return (
        <SimplePageHeader
            title="Personas Overview"
            tools={[]}
        />
    );
};
